import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './contactDetails.scss';

export default function ContactDetailsFilter({ value, onChange, onClear, empty }) {
  const [show, setShow] = useState(false);
  const dialog = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    if (!show) return undefined;
    if (dialog.current.showModal) dialog.current.showModal();
    else dialog.current.setAttribute('open', '');
    return () => { if (trigger.current) trigger.current.focus(); };
  }, [show]);
  const [draft, setDraft] = useState({ mobile: false, email: false });
  const mobile = value === 'missingMobile' || value === 'missingBoth';
  const email = value === 'missingEmail' || value === 'missingBoth';
  const count = Number(mobile) + Number(email);
  const open = () => { setDraft({ mobile, email }); setShow(true); };
  const apply = () => {
    onChange(draft.mobile ? (draft.email ? 'missingBoth' : 'missingMobile') : (draft.email ? 'missingEmail' : 'all'));
    setShow(false);
  };
  return (
    <>
      <button ref={trigger} type="button" className="btn manage-button manage-teal-button contact-filter-button" onClick={open} aria-haspopup="dialog">
        <i className="fas fa-filter mr-2" aria-hidden="true" />Filtry{count ? ` (${count})` : ''}
      </button>
      {(count > 0 || empty) && (
        <div className="contact-active-filters">
          {mobile && <button type="button" className="contact-filter-chip" aria-label="Usuń filtr: Brak telefonu" onClick={() => onChange(email ? 'missingEmail' : 'all')}>Brak telefonu <span aria-hidden="true">×</span></button>}
          {email && <button type="button" className="contact-filter-chip" aria-label="Usuń filtr: Brak e-maila" onClick={() => onChange(mobile ? 'missingMobile' : 'all')}>Brak e-maila <span aria-hidden="true">×</span></button>}
          <button type="button" className="btn btn-link contact-filter-clear" onClick={onClear}>Wyczyść filtry</button>
          {empty && <div className="w-100" role="status">Brak osób spełniających wybrane filtry</div>}
        </div>
      )}
      {show && <dialog ref={dialog} className="contact-filter-dialog" onCancel={() => setShow(false)} aria-labelledby="contact-filters-title">
        <div className="modal-header"><h4 id="contact-filters-title" className="modal-title">Filtry</h4><button type="button" className="close" aria-label="Zamknij filtry" onClick={() => setShow(false)}><span aria-hidden="true">×</span></button></div>
        <div className="modal-body">
          <label className="contact-filter-choice"><input type="checkbox" checked={draft.mobile} onChange={event => setDraft({ ...draft, mobile: event.target.checked })} />Brak telefonu</label>
          <label className="contact-filter-choice"><input type="checkbox" checked={draft.email} onChange={event => setDraft({ ...draft, email: event.target.checked })} />Brak e-maila</label>
          <p className="text-muted mb-0">Oba zaznaczone: osoby bez telefonu i bez e-maila.</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn manage-button manage-teal-button" onClick={() => setShow(false)}>Anuluj</button>
          <button type="button" className="btn manage-button manage-red-button" onClick={apply}>Zastosuj</button>
        </div>
      </dialog>}
    </>
  );
}

ContactDetailsFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  empty: PropTypes.bool.isRequired,
};
